import { render, staticRenderFns } from "./difficulty-icon.vue?vue&type=template&id=1eda4ad6&"
import script from "./difficulty-icon.vue?vue&type=script&lang=js&"
export * from "./difficulty-icon.vue?vue&type=script&lang=js&"
import style0 from "./difficulty-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports